import angular, { ILogService, IOnChangesObject, ITimeoutService } from 'angular'
import { AsyncFilter, FileItem, FileUploader, FileUploaderFactory, SyncFilter } from 'angular-file-upload'
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'
import { CVModel, T_RespModel } from 'src/_candidato/data/cv/CVModel'
import { CVResp } from 'src/_candidato/data/cv/CVResp'
import { $candidatoPublicMod } from 'src/_candidato/public/candidato-public-mod'
import { IICuestionarioPreg } from '../../../../model/candidato-api'
import './start-preg.scss'

class StartPregComponentCtrl {
  q!: IICuestionarioPreg
  superq!: IICuestionarioPreg
  cvmodel!: CVModel
  idx!: number // índice dentro de una row
  params!: { [v: string]: any }
  principal!: boolean

  rows: string[] = []
  others: string[] = []

  cvresp: CVResp
  respmodel: T_RespModel = {
    opt: null,
    opts: null,
    others: null,
    t: null,
    f: null,
    val: null,
    n: null,
    d: null,
    yesno: {
      yes: false,
      no: false,
      details: null,
    },
    valid: true,
  }

  uploader: FileUploader
  uploadReady = false

  inline: boolean
  mostrar: boolean

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private FileUploader: FileUploaderFactory
  ) {}

  $onInit(): void {
    this.$log.info('[StartPregComponentCtrl] onInit')

    // si es de tipo row, una fila por lo menos
    if (this.q.tq == 'ROW' || this.q.tq == 'FILE') {
      this.rows.push('')
    }

    this.cvresp = this.cvmodel.nuevaPreg(this.q, this.superq, this.respmodel, this.idx, this.params)

    this.inline =
      this.q.tq == 'TEXT' ||
      this.q.tq == 'DATE' ||
      this.q.tq == 'NUMBER' ||
      this.q.tq == 'SELECT' ||
      this.q.tq == 'EMAIL' ||
      this.q.tq == 'YESNO'

    this.mostrar = this.q.tq != 'PARAM' && this.q.tq != 'PARAMOCULTO'
  }

  $onChanges(object: IOnChangesObject) {
    // actualizar el idx si cambia
    if (object.idx && angular.isDefined(object.idx.currentValue) && object.idx.currentValue != null && this.cvresp) {
      this.$log.debug('Nuevo idx', object.idx)
      this.cvresp.idx = object.idx.currentValue
    }
  }

  $postLink() {
    this.$timeout(() => {
      ;(this.$element.find('select') as any).formSelect()
      ;(this.$element.find('.datepicker') as any).datepicker({ autoClose: true })
    }, 500)

    if (this.q.tq == 'FILE')
      this.$timeout(() => {
        this.initFileUploads()
      }, 100)
  }

  moreinfo() {
    this.rows.push('')
  }

  addOther() {
    this.others.push('')
  }

  yesnochange(prop: 'yes' | 'no') {
    let val = this.respmodel.yesno[prop]

    if (val) this.respmodel.yesno[prop == 'yes' ? 'no' : 'yes'] = false
  }

  private initFileUploads() {
    let uploader = (this.uploader = new this.FileUploader({
      // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
      //,timeout: 2000
    }))

    this.uploadReady = true

    // uploader.url = BASE_CANDIDATO_API + "api/_cv/n/abc/f"

    // FILTERS

    // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options) {
        console.log('syncFilter')
        return this.queue.length < 10
      } as SyncFilter,
    })

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
        console.log('asyncFilter')
        setTimeout(deferred.resolve, 1e3)
      } as AsyncFilter,
    })

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
      console.info('onWhenAddingFileFailed', item, filter, options)
    }
    uploader.onAfterAddingFile = function (fileItem) {
      if (uploader.queue.length > 1) {
        uploader.removeFromQueue(0)
      }

      console.info('onAfterAddingFile', fileItem)
      console.info('onAfterAddingFile', uploader.queue)
    }
    uploader.onAfterAddingAll = function (addedFileItems) {
      console.info('onAfterAddingAll', addedFileItems)
    }
    uploader.onBeforeUploadItem = function (item: FileItem) {
      console.info('onBeforeUploadItem', item)

      var f = new FormData()

      f.append('foo', '2')

      item.formData.push(f)
    }
    uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem', fileItem, progress)
    }
    uploader.onProgressAll = function (progress) {
      console.info('onProgressAll', progress)
    }
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers)
    }
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers)
    }
    uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers)
    }
    uploader.onCompleteItem = function (fileItem, response, status, headers) {
      console.info('onCompleteItem', fileItem, response, status, headers)
    }

    uploader.onCompleteAll = function () {
      console.info('onCompleteAll')
    }

    console.info('uploader', uploader)

    this.cvresp.uploaderFiles(uploader)
  }

  testUpload() {
    let _up = this.uploader

    this.$log.debug('test uploader', _up.queue)

    _up.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

    let idx = 0
    _up.queue.forEach((f) => {
      f.onComplete = (response, status, headers) => {
        this.$log.debug('Complete!!!!!', status)
      }

      var fd = new FormData()

      fd.append('idx', '' + idx++)

      f.formData = [fd]

      f.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f'

      _up.uploadItem(f)
    })
  }
}

$candidatoPublicMod.component('startPreg', {
  bindings: {
    q: '<',
    superq: '<',
    cvmodel: '<',
    params: '<',
    idx: '<',
    principal: '<',
  },
  controller: StartPregComponentCtrl,
  template: require('./start-preg.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-preg/start-preg.component.html"
})

// inicializar el fileupload de cabecera
